export const Social = () => {
  return (
    <div className="column">
    <ul className="list-none marker:text-blue-500 mb-4">
          <li className="m-2 flex items-center justify-center">
            <a href="https://www.facebook.com/profile.php?id=100092870417691" target="_blank" rel="noreferrer" 
              className="text-gray-700 dark:text-gray-300 hover:text-indigo-700 mr-2 hover:underline">
              Find us on facebook 
            </a>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="16" height="16">
            <linearGradient id="a" x1="-277.375" x2="-277.375" y1="406.6018" y2="407.5726" gradientTransform="matrix(40 0 0 -39.7778 11115.001 16212.334)" gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#0062e0"/>
              <stop offset="1" stopColor="#19afff"/>
            </linearGradient>
            <path fill="url(#a)" d="M16.7 39.8C7.2 38.1 0 29.9 0 20 0 9 9 0 20 0s20 9 20 20c0 9.9-7.2 18.1-16.7 19.8l-1.1-.9h-4.4l-1.1.9z"/>
            <path fill="#fff" d="m27.8 25.6.9-5.6h-5.3v-3.9c0-1.6.6-2.8 3-2.8H29V8.2c-1.4-.2-3-.4-4.4-.4-4.6 0-7.8 2.8-7.8 7.8V20h-5v5.6h5v14.1c1.1.2 2.2.3 3.3.3 1.1 0 2.2-.1 3.3-.3V25.6h4.4z"/>
          </svg>
          </li>
          <li className="m-2 flex items-center justify-center">
            <a href="https://discord.gg/TrVJMwzjKc" target="_blank" rel="noreferrer" 
              className="text-gray-700 dark:text-gray-300 hover:text-indigo-700 mr-2 hover:underline">
              Join the discussion
            </a>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" className="fill-indigo-700 bi bi-discord" viewBox="0 0 16 16"> <path d="M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z"/> </svg>
          </li>
          <li className="m-2 flex items-center justify-center">
            <a href="https://www.reddit.com/r/polygonle" target="_blank" rel="noreferrer" 
              className="text-gray-700 dark:text-gray-300 hover:text-indigo-700 mr-2 hover:underline">
              Say hi on reddit
            </a>
    <svg viewBox="178 89 444 622" height="16" width="16" style={{"strokeWidth": 18, "stroke": "#383940", "fill": "#ffffff"}}>
  <path d="M460 668c36-19 84 7 74 43h-268c-10-36 38-62 74-43h120z"></path>
  <ellipse cx="472" cy="536" rx="72" ry="86"></ellipse>
  <ellipse cx="328" cy="536" rx="72" ry="86"></ellipse>
  <path d="M425 711c55-30 89-158 67-268h-184c-22 110 12 238 67 268h50z"></path>
  <circle cx="578" cy="269" r="44"></circle>
  <circle cx="222" cy="269" r="44"></circle>
  <ellipse cx="400" cy="329" rx="197" ry="129"></ellipse>
  <circle style={{"fill":"#f04a22"}} cx="331" cy="304" r="32"></circle>
  <circle style={{"fill":"#f04a22"}} cx="469" cy="304" r="32"></circle>
  <path style={{"strokeLinecap": "round", "fill": "none", "strokeLinejoin": "round"}} d="M521 116l-88-20-32 102M468 388s-16 21-68 21-68-21-68-21"></path>
  <circle cx="556" cy="123" r="34"></circle>
</svg>
          </li>
          <li className="m-2 flex items-center justify-center">
            <a href="https://twitter.com/PolygonleGame" target="_blank" rel="noreferrer"
              className="text-gray-700 dark:text-gray-300 hover:text-indigo-700 mr-2 hover:underline">
              Follow our twitter
            </a>
						<svg width="16" height="16" viewBox="328 355 335 276" xmlns="http://www.w3.org/2000/svg">
  					<path d="M 630, 425
  					  A 195, 195 0 0 1 331, 600
  					  A 142, 142 0 0 0 428, 570
  					  A  70,  70 0 0 1 370, 523
  					  A  70,  70 0 0 0 401, 521
  					  A  70,  70 0 0 1 344, 455
  					  A  70,  70 0 0 0 372, 460
  					  A  70,  70 0 0 1 354, 370
  					  A 195, 195 0 0 0 495, 442
  					  A  67,  67 0 0 1 611, 380
  					  A 117, 117 0 0 0 654, 363
  					  A  65,  65 0 0 1 623, 401
  					  A 117, 117 0 0 0 662, 390
  					  A  65,  65 0 0 1 630, 425
  					  Z"
  					  style={{"fill":"#3BA9EE"}} /></svg>
          </li>
          <li className="m-2 flex items-center justify-center">
            <a href="https://www.buymeacoffee.com/blorppppp" target="_blank" rel="noreferrer"
              className="text-gray-700 dark:text-gray-300 hover:text-indigo-700 mr-2 hover:underline">
              Buy me a coffee
            </a>☕
          </li>
        </ul>
      </div>)
}
